var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0V0C46.5685 0 60 13.4315 60 30V30C60 46.5685 46.5685 60 30 60V60C13.4315 60 0 46.5685 0 30V30Z",
    fill: "#DAC9B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6598 19.6364H35.1257V34.1932C35.1257 35.4924 34.8871 36.5961 34.4098 37.5043C33.9325 38.4124 33.2597 39.1018 32.3913 39.5724C31.523 40.0431 30.4988 40.2784 29.3189 40.2784C28.2053 40.2784 27.2143 40.0762 26.3459 39.6719C25.4775 39.2609 24.7947 38.6776 24.2976 37.9219C23.8004 37.1662 23.5518 36.268 23.5518 35.2273H25.978C25.978 35.804 26.1205 36.3078 26.4055 36.7386C26.6972 37.1629 27.0949 37.4943 27.5987 37.733C28.1025 37.9716 28.6759 38.0909 29.3189 38.0909C30.0282 38.0909 30.6314 37.9418 31.1286 37.6435C31.6257 37.3452 32.0036 36.9077 32.2621 36.331C32.5272 35.7476 32.6598 35.035 32.6598 34.1932V19.6364Z",
    fill: "#633F11"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ);
export default __webpack_public_path__ + "static/media/j.9ab55ee3fde8b73f759356ed6a75aadf.svg";
export { ForwardRef as ReactComponent };